import {
    IJobsBoardFilter,
    IJobsBoardFormValues,
    IJobStepObject,
    IJobStepsForm,
    ISaveJobForm,
    JobStepObjectFields,
    JobStepsFormFields,
    SAVE_JOB_FORM_VALUES,
} from '../interfaces';

export enum JobStatus {
    Draft = 'DRAFT',
    Published = 'PUBLISHED',
    Closed = 'CLOSED',
    Suspended = 'SUSPENDED',
    Canceled = 'CANCELED',
    Completed = 'COMPLETED',
    Legacy = 'LEGACY',
}

export const jobsBoardFiltersInitState: Array<IJobsBoardFilter> = [
    {
        title: 'jobType',
        name: IJobsBoardFormValues.jobTypes,
        type: 'checkbox',
        options: [],
        shouldShow: false,
    },
    {
        title: 'location',
        name: IJobsBoardFormValues.location,
        type: 'checkbox',
        options: [],
        shouldShow: false,
    },
    {
        title: 'remoteJob',
        name: IJobsBoardFormValues.isRemote,
        type: 'boolean',
        shouldShow: false,
    },
    {
        title: 'hybridJob',
        name: IJobsBoardFormValues.isHybrid,
        type: 'boolean',
        shouldShow: false,
    },
];

export const emptySaveJobForm: ISaveJobForm = {
    [SAVE_JOB_FORM_VALUES.TITLE]: '',
    [SAVE_JOB_FORM_VALUES.LOCATION]: '',
    [SAVE_JOB_FORM_VALUES.EXTERNAL_JOB_ID]: '',
    [SAVE_JOB_FORM_VALUES.ATTRIBUTE]: [],
    [SAVE_JOB_FORM_VALUES.RECRUITING_MANAGER]: null,
    [SAVE_JOB_FORM_VALUES.RECRUITER]: null,
    [SAVE_JOB_FORM_VALUES.COMPANY_OVERVIEW]: '',
    [SAVE_JOB_FORM_VALUES.JOB_OVERVIEW]: '',
    [SAVE_JOB_FORM_VALUES.RESPONSIBILITIES]: '',
    [SAVE_JOB_FORM_VALUES.JOB_REQUIREMENTS]: [],
    [SAVE_JOB_FORM_VALUES.JOB_BENEFITS]: [],
    [SAVE_JOB_FORM_VALUES.STEPS]: [],
    [SAVE_JOB_FORM_VALUES.STEPS_SELECTED_JOB]: null,
    [SAVE_JOB_FORM_VALUES.QUESTIONS]: [],
    [SAVE_JOB_FORM_VALUES.QUESTIONS_SELECTED_JOB]: null,
};

export const jobStepperInfoInitState = {
    steps: [
        { labelText: '1' },
        { labelText: '2' },
        { labelText: '3' },
        { labelText: '4' },
        { labelText: '5' },
    ],
    activeStepIndex: 0,
};

export enum JobAttribute {
    JobType = 'Job Type',
    EmploymentType = 'Employment Type',
    EmploymentPeriod = 'Employment Period',
    EmploymentModel = 'Employment Model',
}

export const emptyJobStepsForm: IJobStepsForm = {
    [JobStepsFormFields.STEPS]: [],
    [JobStepsFormFields.SELECTED_JOB]: null,
};

export const jobStepObjectInitState: IJobStepObject = {
    [JobStepObjectFields.ID]: '',
    [JobStepObjectFields.STEP_NAME]: '',
    [JobStepObjectFields.STEP_OWNER]: null,
    [JobStepObjectFields.INTERVIEWERS]: [],
    [JobStepObjectFields.IS_FIRST_STEP]: false,
    [JobStepObjectFields.IS_LAST_STEP]: false,
};
